import { useCallback, useRef } from 'react';

/** The distance in pixels a finger must move down before the sheet closes. */
export const SWIPE_CLOSE_DISTANCE = 80;

/** The bottom sheet layout of the confirm dialog starts below this width (ConfirmDialog.module.scss). */
const SHEET_MEDIA_QUERY = '(width <= 575.98px)';

function isSheetLayout(): boolean {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(SHEET_MEDIA_QUERY).matches
    : false;
}

/**
 * On a narrow screen the confirm dialog is a bottom sheet, and a swipe down closes it like
 * Cancel (design dialogs a7). With no `onClose` (the action runs), a swipe does nothing.
 */
export function useSwipeDownToClose(onClose: (() => void) | undefined) {
  const startY = useRef<number | null>(null);

  const onTouchStart = useCallback((event: React.TouchEvent) => {
    const touch = event.touches.length === 1 ? event.touches[0] : undefined;
    startY.current = isSheetLayout() && touch !== undefined ? touch.clientY : null;
  }, []);

  const onTouchEnd = useCallback(
    (event: React.TouchEvent) => {
      const start = startY.current;
      startY.current = null;
      const touch = event.changedTouches[0];
      if (start === null || onClose === undefined || touch === undefined) {
        return;
      }
      if (touch.clientY - start >= SWIPE_CLOSE_DISTANCE) {
        onClose();
      }
    },
    [onClose]
  );

  return { onTouchStart, onTouchEnd };
}
